module.exports = __webpack_public_path__ + "static/media/Message.35fc1a50.png";